import React from 'react';
import { Status, Priority } from '../types';

interface FilterBarProps {
  statusFilter: Status | 'All';
  priorityFilter: Priority | 'All';
  onStatusChange: (value: Status | 'All') => void;
  onPriorityChange: (value: Priority | 'All') => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export default function FilterBar({
  statusFilter,
  priorityFilter,
  onStatusChange,
  onPriorityChange,
  searchQuery,
  onSearchChange,
}: FilterBarProps) {
  return (
    <div className="filter-bar">
      <div className="filter-search">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="search-icon">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          placeholder="Search issues..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="filter-controls">
        <div className="filter-group">
          <label className="filter-label">Status</label>
          <div className="filter-chips">
            {(['All', 'Open', 'In Progress', 'Closed'] as (Status | 'All')[]).map((s) => (
              <button
                key={s}
                className={`filter-chip ${statusFilter === s ? 'active' : ''}`}
                onClick={() => onStatusChange(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Priority</label>
          <div className="filter-chips">
            {(['All', 'High', 'Medium', 'Low'] as (Priority | 'All')[]).map((p) => (
              <button
                key={p}
                className={`filter-chip ${priorityFilter === p ? 'active' : ''} ${p !== 'All' ? `priority-chip-${p.toLowerCase()}` : ''}`}
                onClick={() => onPriorityChange(p)}
              >
                {p}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
